import { Box3, Vector3 } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export class Controls {
  constructor(camera, domElement) {
    this.camera = camera;
    this.controls = new OrbitControls(camera, domElement);
    this.controls.enableDamping = true; // inertia
    this.controls.dampingFactor = 0.05;
  }

  getControls() {
    return this.controls;
  }

  setControlsDistance(object) {
    const box = new Box3().setFromObject(object);
    const size = box.getSize(new Vector3()).length();

    // min/max zoom
    this.controls.maxDistance = size / Math.tan((this.camera.fov * Math.PI) / 360);
    this.controls.minDistance = this.controls.maxDistance / 3;

    this.controls.saveState();
  }

  zoomIn = () => {
    this.controls.zoomIn();
  };

  zoomOut = () => {
    this.controls.zoomOut();
  };
}
